import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessageCenterOutlinedmin = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10.875 12a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0Zm4.688 0a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0Zm-9.375 0a1.125 1.125 0 1 0 2.25 0 1.125 1.125 0 0 0-2.25 0Zm15.497-4.069a10.505 10.505 0 0 0-5.616-5.615A10.45 10.45 0 0 0 12 1.5h-.047A10.475 10.475 0 0 0 1.5 12.05a10.533 10.533 0 0 0 1.125 4.684v3.563a1.078 1.078 0 0 0 1.078 1.078h3.565a10.533 10.533 0 0 0 4.685 1.125h.05c1.403 0 2.765-.272 4.047-.804a10.417 10.417 0 0 0 3.347-2.231 10.473 10.473 0 0 0 3.103-7.418 10.459 10.459 0 0 0-.816-4.116Zm-3.542 10.266A8.673 8.673 0 0 1 12 20.719h-.04a8.75 8.75 0 0 1-4.057-1.02l-.197-.105h-3.3v-3.3l-.105-.197a8.75 8.75 0 0 1-1.02-4.057 8.665 8.665 0 0 1 2.522-6.183 8.653 8.653 0 0 1 6.16-2.576h.04c1.171 0 2.308.228 3.38.678a8.662 8.662 0 0 1 2.788 1.875 8.683 8.683 0 0 1 2.552 6.206 8.686 8.686 0 0 1-2.58 6.157Z"
	})
});
const ForwardRef = forwardRef(SvgMessageCenterOutlinedmin);
export { ForwardRef as ReactComponent };
